export const IS_QA_MODE_ENABLED_PROP_NAME = 'isQAModeEnabled';

export function isQAModeEnabled(): boolean {
    return Boolean(window[IS_QA_MODE_ENABLED_PROP_NAME]);
}